import { render, staticRenderFns } from "./TransactionRecap.vue?vue&type=template&id=bfe618fe&scoped=true"
import script from "./TransactionRecap.vue?vue&type=script&lang=js"
export * from "./TransactionRecap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfe618fe",
  null
  
)

export default component.exports